import React, { useState } from 'react';
import { useNavigate, Link } from 'react-router-dom';
import { toast } from 'react-toastify';
import { registerCliente } from '../services/api';
import './CadastroCliente.css';

const CadastroCliente = () => {
  const navigate = useNavigate();
  const [formData, setFormData] = useState({
    nome: '',
    email: '',
    senha: '',
    confirmarSenha: '',
    telefone: '',
    endereco: '',
    cidade: '',
    estado: '',
    cep: ''
  });
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState('');

  const handleChange = (e) => {
    setFormData({
      ...formData,
      [e.target.name]: e.target.value
    });
    setError('');
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    setError('');

    if (formData.senha !== formData.confirmarSenha) {
      setError('As senhas não coincidem');
      return;
    }

    if (formData.senha.length < 6) {
      setError('A senha deve ter pelo menos 6 caracteres');
      return;
    }

    setLoading(true);

    try {
      const { confirmarSenha, ...dataToSend } = formData;
      const response = await registerCliente(dataToSend);
      
      localStorage.setItem('token', response.data.token);
      localStorage.setItem('cliente', JSON.stringify(response.data.cliente));
      
      toast.success('Cadastro realizado com sucesso!');
      navigate('/');
      window.location.reload();
    } catch (error) {
      console.error('Erro ao cadastrar cliente:', error);
      setError(error.response?.data?.error || 'Erro ao realizar cadastro. Tente novamente.');
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="cadastro-cliente-page">
      <div className="cadastro-cliente-container">
        <h1 className="cadastro-cliente-title">Cadastro de Cliente</h1>
        <p className="cadastro-cliente-subtitle">Preencha os dados abaixo para criar sua conta</p>

        {error && <div className="cadastro-cliente-error" role="alert">{error}</div>}

        <form onSubmit={handleSubmit} className="cadastro-cliente-form" noValidate>
          <section className="cadastro-section" aria-labelledby="dados-pessoais">
            <h2 id="dados-pessoais" className="cadastro-section-title">Dados pessoais</h2>

            <div className="cadastro-field">
              <label htmlFor="nome">Nome completo *</label>
              <input
                type="text"
                id="nome"
                name="nome"
                value={formData.nome}
                onChange={handleChange}
                required
                autoComplete="name"
                placeholder="Ex: Maria Silva"
              />
            </div>

            <div className="cadastro-row">
              <div className="cadastro-field">
                <label htmlFor="email">E-mail *</label>
                <input
                  type="email"
                  id="email"
                  name="email"
                  value={formData.email}
                  onChange={handleChange}
                  required
                  autoComplete="email"
                  placeholder="seu@email.com"
                />
              </div>
              <div className="cadastro-field">
                <label htmlFor="telefone">Telefone</label>
                <input
                  type="tel"
                  id="telefone"
                  name="telefone"
                  value={formData.telefone}
                  onChange={handleChange}
                  autoComplete="tel"
                  placeholder="(11) 99999-9999"
                />
              </div>
            </div>

            <div className="cadastro-row">
              <div className="cadastro-field">
                <label htmlFor="senha">Senha *</label>
                <input
                  type="password"
                  id="senha"
                  name="senha"
                  value={formData.senha}
                  onChange={handleChange}
                  required
                  minLength={6}
                  autoComplete="new-password"
                  placeholder="Mínimo 6 caracteres"
                />
              </div>
              <div className="cadastro-field">
                <label htmlFor="confirmarSenha">Confirmar senha *</label>
                <input
                  type="password"
                  id="confirmarSenha"
                  name="confirmarSenha"
                  value={formData.confirmarSenha}
                  onChange={handleChange}
                  required
                  autoComplete="new-password"
                  placeholder="Repita a senha"
                />
              </div>
            </div>
          </section>

          <section className="cadastro-section" aria-labelledby="endereco">
            <h2 id="endereco" className="cadastro-section-title">Endereço</h2>

            <div className="cadastro-field">
              <label htmlFor="endereco">Logradouro</label>
              <input
                type="text"
                id="endereco"
                name="endereco"
                value={formData.endereco}
                onChange={handleChange}
                autoComplete="street-address"
                placeholder="Rua, número e complemento"
              />
            </div>

            <div className="cadastro-row cadastro-row-3">
              <div className="cadastro-field cadastro-field-cep">
                <label htmlFor="cep">CEP</label>
                <input
                  type="text"
                  id="cep"
                  name="cep"
                  value={formData.cep}
                  onChange={handleChange}
                  autoComplete="postal-code"
                  placeholder="00000-000"
                  maxLength={9}
                />
              </div>
              <div className="cadastro-field">
                <label htmlFor="cidade">Cidade</label>
                <input
                  type="text"
                  id="cidade"
                  name="cidade"
                  value={formData.cidade}
                  onChange={handleChange}
                  autoComplete="address-level2"
                  placeholder="Cidade"
                />
              </div>
              <div className="cadastro-field cadastro-field-uf">
                <label htmlFor="estado">UF</label>
                <input
                  type="text"
                  id="estado"
                  name="estado"
                  value={formData.estado}
                  onChange={handleChange}
                  autoComplete="address-level1"
                  placeholder="UF"
                  maxLength={2}
                />
              </div>
            </div>
          </section>

          <div className="cadastro-actions">
            <button type="submit" className="cadastro-btn-submit" disabled={loading}>
              {loading ? 'Cadastrando...' : 'Criar conta'}
            </button>
          </div>

          <p className="cadastro-footer">
            Já tem uma conta? <Link to="/login">Fazer login</Link>
          </p>
        </form>
      </div>
    </div>
  );
};

export default CadastroCliente;

